import React from 'react';
import { SchemaStatuses } from 'constants/schemaStatuses';
import FPChip from 'UI/components/atoms/FPChip';

import { STATUSES_INFO } from './FPFormStatus.constants';

/**
 * @param {Object} props
 * @param {string} props.status
 * @param {number} [props.totalQuestions]
 * @param {number} [props.totalAnsweredQuestions=0]
 * @param {boolean} [props.shouldShowTotal=true]
 */
const FPFormStatus = ({ status, totalQuestions, totalAnsweredQuestions, shouldShowTotal }) => {
  const total =
    shouldShowTotal && status === SchemaStatuses.InProgress
      ? ` ${totalAnsweredQuestions}/${totalQuestions}`
      : '';

  const statusLabel = `${STATUSES_INFO[status].label}${total}`;
  const statusColor = STATUSES_INFO[status].color;
  return (
    <FPChip
      label={statusLabel}
      variant="outlined"
      color={statusColor}
      textColor={statusColor}
      size="small"
    />
  );
};

FPFormStatus.defaultProps = {
  totalAnsweredQuestions: 0,
  shouldShowTotal: true
};

export default FPFormStatus;
